import { ComboBoxModel } from "@genexus/chameleon-controls-library";
import { ObjectType, GxOption } from "../../../common/types";
import { ComboBoxItemModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";
import { ItemNode } from "../../select-kb-items/select-kb-items";

export const mapObjectTypeToComboBoxItemModel = (
  objectTypeModel: ObjectType[]
): ComboBoxItemModel[] =>
  objectTypeModel.map(objectType => ({
    value: objectType.id,
    caption: objectType.name,
    startImgSrc: objectType.icon
  }));

export const mapCategoryToComboBoxItemModel = (
  categoryModel: GxOption[]
): ComboBoxModel =>
  categoryModel.map(category => ({
    value: category.id,
    caption: category.label
  }));

const hasActiveNode = (node: any): boolean => {
  if (node.active) {
    return true;
  }
  if (Array.isArray(node.nodes)) {
    return node.nodes.some(hasActiveNode);
  }
  return false;
};

export const hasActiveVersionInList = (versionsList: ItemNode[]): boolean => {
  return versionsList.some(hasActiveNode);
};
